module.exports = __webpack_public_path__ + "img/0x88da18a5bca86ec8206d9b4960a7d0c4355a432f.ec85eac8.png";